import { render, staticRenderFns } from "./flightResults.vue?vue&type=template&id=5fca2ffe&scoped=true"
import script from "./flightResults.vue?vue&type=script&lang=js"
export * from "./flightResults.vue?vue&type=script&lang=js"
import style0 from "./flightResults.vue?vue&type=style&index=0&id=5fca2ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca2ffe",
  null
  
)

export default component.exports